const PACKAGE_NAME = '@jtl-software/platform-ui-react';

export default PACKAGE_NAME;
